import { Eye, Users, User } from '@phosphor-icons/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { environment } from '../../env';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import "../BuildingViewCard/BuildingDropDown.css"
import EmptyDoc from './../errorComponents/EmptyDoc';
import DocumentsCard from './../DocumentsCard/DocumentsCard';
import Table from '../Table';
import EmptyTable from '../errorComponents/EmptyTable';
import InvestorViewCard from './InvestorViewCard';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Button
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import PathName from '../PathName/PathName';
import WarningPopup from '../Popups/WarningPopup';
import { warningModalToggle } from '../../redux/actions/Index';

function SoldGalaViewCard() {
    const { id } = useParams()
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [docs, setDocs] = useState([])
    const [data, setData] = useState([])
    const [jointOwnerDetails, setJointOwnerDetails] = useState();
    const [allPrevInvestors, setAllPrevInvestors] = useState([]);
    const [oldInvstToggle, setOldInvstToggle] = useState(false);
    const [resaleGala, setResaleGala] = useState([])
    const resaleGalaData = id.split(':')[1] == 'history' ? resaleGala?.[0]?.new_investor : resaleGala?.[0]?.old_investor
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const navigate = useNavigate();
    const soldGalaList = useSelector((state) => state?.ModalReducer?.soldGalaList);
    const dispatch = useDispatch()
    console.log('========================', id.split(':')[0], id.split(':')[1])
    const ViewData = () => {
        let dataSoldGalaList = soldGalaList.filter(data => data.id == Number(id.split(':')[0]))
        setData(dataSoldGalaList)

        if (dataSoldGalaList[0]?.ownertype == 'Joined') {
            let fetchedJntOwnDetails = soldGalaList?.filter(jOwnerDetails => jOwnerDetails.group_id == dataSoldGalaList[0]?.group_id)
            if (fetchedJntOwnDetails != undefined) {
                setJointOwnerDetails(fetchedJntOwnDetails)
            }
        }
    }

    useEffect(() => {
        let ownershipStatus = resaleGala?.code;
        let haveOldInvestor = true;
        if (ownershipStatus == undefined) {
            if (resaleGala.length == 0) {
                haveOldInvestor = false;
            }
        } else if (ownershipStatus == 400) {
            haveOldInvestor = false;
        }
        if (data[0]?.ownership != 1 && haveOldInvestor) {
            let oldInvestorArray = resaleGala?.map(eachInvestor => eachInvestor?.old_investor)
            setAllPrevInvestors(oldInvestorArray);
        }
    }, [resaleGala])

    const jntInvestorTabCol = [
        {
            name: 'Status',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={`${row.ownership === 1 && 'icon-bg-green icon-color-green '} ${row.ownership === 2 && 'icon-bg-yellow icon-color-yellow'} ${row.ownership == 3 && 'status-bg-blue status-color-blue'} ${row.ownership >= 4 && 'bg-info text-white'}   rounded-pill status-box rounded fs-4`}>{`${ordinal(row.ownership)} Owner`}</label>
            </div>,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Owner Type',
            selector: row => <div className="d-flex justify-content-between align-items-center gap-3 " >
                <span>{row?.ownertype == "Self" ? <User size="26" className='text-base-red' /> : row?.ownertype == "Joined" && <Users size="26" className='status-color-blue' />}</span>
                <label className='fs-3'>{row?.ownertype}</label>
            </div >,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Party Name',
            selector: row => row.Investors?.name,
            sortable: true,
            wrap: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Created On',
            selector: row => moment(row.created_at).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building No',
            selector: row => row.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },

        {
            name: 'Gala No',
            selector: row => Number(row.gala?.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }, {
            name: 'Sub Gala',
            selector: row => row.sub_gala_name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.sold_gala_area - row.resell_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        // {
        //   name: 'Upload',
        //   cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        //     <DocUploadModal type={"soldgala"} soldGalaId={row?.id} />
        //   </div>,
        // },
        // {
        //   name: 'Action',
        //   cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        //     <Link to={`/SoldGalas/${row.id}`} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
        //   </div>,
        // },
    ];

    const GetDocs = () => {
        axios.get(`${environment.baseUrl}upload-sold-gala-doc/`).then(res => {
            let documents = res.data.filter((doc) => doc.soldgala == Number(id.split(':')[0]))
            setDocs(documents)
        })
            .catch(res => {
                console.log("errorss");
            })
    }

    const getResaleGala = async () => {
        if (id.split(':')[1] == 'history') {
            await axios.get(`${environment.baseUrl}resell-gala-histo/${Number(id.split(':')[0])}`).then((res) => setResaleGala(res.data))
        } else {
            await axios.get(`${environment.baseUrl}resell-gala-history/${Number(id.split(':')[0])}`).then((res) => setResaleGala(res.data))
        }
    }

    const ordinal = (i) => {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }

    useEffect(() => {
        getResaleGala()
        GetDocs();
        ViewData();
    }, [])

    const deleteDocument = (id) => {
        dispatch(warningModalToggle(id));
    }

    const deleteDoc = (id) => {
        axios.put(`${environment.baseUrl}editsold-gala-doc/${id}`, { view: 1 }).then(res => {
            if (res.data.code === 200) {
                GetDocs();
            }
        })
            .catch(res => {
                console.log("error");
            })

    }

    return (
        <div className="">
            <WarningPopup deleteData={deleteDoc} />
            <PathName />
            <div className="d-flex justify-content-between align-items-center py-5 px-3 pt-2">
                <button className="d-flex align-items-center border-0 bg-transparent" onClick={() => navigate(-1)}>
                    <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
                    <span className='fs-3 base-font-600'>Back</span> </button>
            </div>
            <h1 className='title-font-bold py-3 px-2'>{id.split(':')[1] == 'history' ? `Previous Investor Details` : `Current Investor Details`}  </h1>
            <div className="bg-white d-flex mb-5  flex-column border-radius-32">
                <div className="card w-100 border-0 rounded-5 shadow p-3 p-sm-4 p-md-5 p-lg-5 p-xl-5 ">
                    <div className="row align-items-center justify-content-center py-3">
                        <div className="col-12 row py-3">
                            <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                                <h5 className="fs-3 title-font-800 text-base-black">Party Name :  <span className='fs-3 base-font-500 text-black'>{data[0]?.Investors?.name}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Sale Date : <span className='fs-3 base-font-500 text-black'>{moment(data[0]?.created_at).format('DD/MM/YYYY')}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Building No :  <span className='fs-3 base-font-500 text-black'>{data[0]?.building?.building_no}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Gala No : <span className='fs-3 base-font-500 text-black'>{data[0]?.gala?.gala_no}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Index No : <span className='fs-3 base-font-500 text-black'>{data[0]?.index == "" ? "NA" : data[0]?.index}</span></h5>
                            </div>
                            <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                                <h5 className="fs-3 title-font-800 text-base-black">Owner Type : <span className='fs-3 base-font-500 text-black'>{data[0]?.ownertype}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Sub Gala :  <span className='fs-3 base-font-500 text-black'>{data[0]?.sub_gala_name}</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Area : <span className='fs-3 base-font-500 text-black'>{data[0]?.sold_gala_area - data[0]?.resell_area} Sq.ft</span> </h5>
                                <h5 className="fs-3 title-font-800 text-base-black">Status : <span className='fs-3 base-font-500 text-black'>{ordinal(data[0]?.ownership)} Owner</span> </h5>
                                {data[0]?.ownership > 1 && <h5 className="fs-3 title-font-800 text-base-black">Reason for Resell : <span className='fs-3 base-font-500 text-black'>{data[0]?.resell_reason}</span> </h5>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {allPrevInvestors.length != 0 && <>
                <div className="bg-white p-5 d-flex flex-column rounded-5 mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <h1 className='title-font-bold py-3 px-2'>Previous Investors</h1>
                        <Button
                            onClick={() => setOldInvstToggle(!oldInvstToggle)}
                            className="fs-3 py-3 px-5 bg-base-color text-base-white border-0 btn btn-secondary shadow-none"
                        >
                            {oldInvstToggle ? "Hide" : "Show"}
                        </Button>
                    </div>
                    <div className="bg-white p-1 d-flex gap-5 flex-column rounded-5 mt-4 mb-5">
                        {allPrevInvestors?.map(eachOldInvData => (<InvestorViewCard investorData={eachOldInvData} detailsToggler={oldInvstToggle} />))}
                    </div>
                </div>
            </>}
            {/* {
                resaleGalaData != undefined && <>
                    <h1 className='title-font-bold py-3 px-2'>{id.split(':')[1] != 'history' ? `Previous Investor Details` : `Current Investor Details`}</h1>
                    <div className="bg-white d-flex mb-5  flex-column border-radius-32">
                        <div className="card w-100 border-0 rounded-5 shadow p-3 p-sm-4 p-md-5 p-lg-5 p-xl-5 ">
                            <div className="row align-items-center justify-content-center py-3">
                                <div className="col-12 row py-3">
                                    <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                                        <h5 className="fs-3 title-font-800 text-base-black">Party Name :  <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.Investors?.name}</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Contact No :  <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.Investors?.contact_number}</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Sale on : <span className='fs-3 base-font-500 text-black'>{moment(resaleGalaData?.created_at).format('DD/MM/YYYY')}</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Building No :  <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.building
                                            ?.building_no
                                        }</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Gala No : <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.gala
                                            ?.gala_no
                                        }</span> </h5>
                                    </div>
                                    <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                                        <h5 className="fs-3 title-font-800 text-base-black">Address : <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.Investors?.address}</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Owner Type : <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.ownertype}</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Sub Gala :  <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.sub_gala_name}</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Area : <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.sold_gala_area - resaleGalaData?.resell_area} Sq.ft</span> </h5>
                                        <h5 className="fs-3 title-font-800 text-base-black">Status : <span className='fs-3 base-font-500 text-black'>{ordinal(resaleGalaData?.ownership)} Owner</span> </h5>
                                        {resaleGalaData?.ownership > 1 && <h5 className="fs-3 title-font-800 text-base-black">Reason for Resell : <span className='fs-3 base-font-500 text-black'>{resaleGalaData?.resell_reason}</span> </h5>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            } */}
            {/* {allPrevInvestors.length != 0 && <>
                <h1 className='title-font-bold py-3 px-2'>Old Investors</h1>
                <div className="bg-white p-5 shadow-sm mb-5 border-radius-32">
                    <div className="bg-white border-radius-0">
                        <Table columns={oldInvestorTabCol} data={allPrevInvestors} />
                    </div>
                </div>
            </>} */}
            {jointOwnerDetails != undefined && jointOwnerDetails?.length != 0 && <>
                <h1 className='title-font-bold py-3 px-2'>Joined Partners</h1>
                <div className="bg-white p-5 shadow-sm mb-5 border-radius-32">
                    <div className="bg-white border-radius-0">
                        {jointOwnerDetails?.length != 0 ? <Table columns={jntInvestorTabCol} data={jointOwnerDetails} /> : <EmptyTable />}
                    </div>
                </div></>
            }
            <div className="bg-white d-flex mb-5  flex-column border-radius-32">
                <div className='d-flex flex-column justify-content-center align-items-strat align-items-md-center  align-items-lg-center align-items-xl-center align-items-sm-center bg-base-color p-4 border-radius-32-top'>
                    <h1 className='title-font-600 text-base-white fs3'>SOLD GALA DOCUMENTS</h1>
                </div>
                {(docs?.length != 0 && docs != undefined) ?
                    (<div className="bg-white p-5 d-flex gap-5 flex-column justify-content-center align-items-center rounded-5 mb-5">
                        <DocumentsCard documentDetails={docs} soldgala={true} handle={deleteDocument} />
                    </div>)
                    : (<div className="bg-white p-5 d-flex gap-5 flex-column justify-content-center align-items-center rounded-5 mb-5">
                        <h1 className="text-base-color title-font-700 text-capitalize">No Documents available...🤷🏻‍♂️</h1>
                    </div>)}
            </div>
        </div>

    )
}

export default SoldGalaViewCard


